import { createSlice } from "@reduxjs/toolkit"

export const initialState = {
  loading: false,
  error: null,
  orders: [],
  order: null
}

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setLoading: state => {
      state.loading = true
    },
    setOrders: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.orders = payload
    },
    setOrder: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.order = payload
    },
    orderCreated: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.orders = [payload, ...state.orders]
    },
    orderUpdated: (state, { payload }) => {
      state.loading = false
      state.error = null
      const index = state.orders.findIndex(o => o._id === payload._id)
      if (index !== -1) {
        state.orders[index] = payload
      }
      if (state.order && state.order._id === payload._id) {
        state.order = payload
      }
    },
    orderDeleted: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.orders = state.orders.filter(o => o._id !== payload)
      if (state.order && state.order._id === payload) {
        state.order = null
      }
    },
    setError: (state, { payload }) => {
      state.loading = false
      state.error = payload
    }
  }
})

export const { setLoading, setOrders, setOrder, orderCreated, orderUpdated, orderDeleted, setError } = orderSlice.actions

export default orderSlice.reducer
